import React, { useState, useEffect } from 'react';
import {
  IonContent,
  IonPage,
  IonLoading,
  IonCardHeader,
  IonCardSubtitle,
  IonCardTitle
} from '@ionic/react';
import './NewsSingle.scss';
import AppHeader from '../components/AppHeader';
import { RouteComponentProps } from 'react-router-dom';
import PostRepository from '../repositories/PostRepository';
import Post from '../models/Post';

interface NewsSingleProps
  extends RouteComponentProps<{
    id: string;
  }> {}

const NewsSingle: React.FC<NewsSingleProps> = ({ match }) => {
  const [isLoading, setIsLoading] = useState(false);
  const [post, setPost] = useState<Post>();

  useEffect(() => {
    async function fetchSlots() {
      setIsLoading(true);
      const posts = await PostRepository.findAll();
      // eslint-disable-next-line eqeqeq
      setPost(posts.find((post) => post.id == match.params.id));
      setIsLoading(false);
    }

    fetchSlots();
  }, [match.params.id]);

  return (
    <IonPage className="news-single">
      <IonLoading isOpen={isLoading} />
      <AppHeader defaultBackLink="/dashboard/actualites" />
      {!isLoading ? (
        <IonContent>
          <div className="wrapper wrapper--large">
            <div className="ion-text-center">
              <img
                src={post?.thumbnail}
                alt={post?.title}
                className="news-thumbnail"
              />
            </div>
            <div className="ion-padding">
              <IonCardHeader className="ion-no-padding">
                <IonCardSubtitle>
                  {post?.created_at.toLocaleDateString('fr-FR')}
                </IonCardSubtitle>
                <IonCardTitle>{post?.title}</IonCardTitle>
              </IonCardHeader>
              <div
                dangerouslySetInnerHTML={{ __html: post?.content || '' }}
                className="ion-text-content"
              ></div>
            </div>
          </div>
        </IonContent>
      ) : null}
    </IonPage>
  );
};

export default NewsSingle;
